<app-popover 
  (closeCallback)="cancelCallback()"
  size="medium">
  <div popover-header class="action-header-wrapper">
    
      <img src="../../../../assets/cancel.svg" class="action-dialog-icon" alt="">
   
    <div>
      {{title}}
    </div>
    <!-- <div class="booking-details-header">

      {{title}} 
    </div> -->
  </div>
  <div
    *ngIf="!isYesClicked else reasontemplate;"
    popover-content
    class="content-section"
  >
   {{confirmationText}} - {{bookingOrRequestId}} ?
  </div>
  <ng-template #reasontemplate>
    <div class="mb-10 fs-14">Please provide the reason <span class="optional" *ngIf="!cancelPopupConfig.config.mandatory">(optional)</span></div>
    <textarea class="cancel-rsn" 
    name="reason" type="text" [(ngModel)]="reasonText" [maxlength]="maxLimit"
      #reasonControl="ngModel" rows="3"
      [required]="cancelPopupConfig.config.visibility.visible && cancelPopupConfig.config.mandatory"></textarea>
    <div *ngIf="reasonControl.invalid">
      <div class="error-msg fs-12" *ngIf="isSubmitReasonClicked && reasonControl.errors.required">This Field is mandatory</div>
      <div class="error-msg fs-12" *ngIf="reasonControl.errors.maxlength">Limit Exceeded (Max limit - 200 characters)</div>
    </div>
  </ng-template>
  <div popover-actions class="actions-section">
    <app-button
      class="mr-10"
      type="plainText"
      text="No"
      (clickCallback)="cancelCallback()"
      >
    </app-button>
    <app-button
      type="primaryFilled"
      [text]="isYesClicked ? 'Submit' : 'Yes'"
      (clickCallback)="isYesClicked ? submitReasonAndCancel() : onYesClick()"
    ></app-button>
  </div>
</app-popover>